import { render, staticRenderFns } from "./table-columns-drawer.vue?vue&type=template&id=a8375388&"
import script from "./table-columns-drawer.vue?vue&type=script&lang=js&"
export * from "./table-columns-drawer.vue?vue&type=script&lang=js&"
import style0 from "./table-columns-drawer.vue?vue&type=style&index=0&id=a8375388&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports